import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';
import { OrderingData } from '../../../../core/modal/ordering-data';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

const BASE_API_URL = '';

@Injectable({
  providedIn: 'root'
})
export class AllocationIpSelectService {
  constructor(private http: HttpClient) {

  }

  getIpPoolAll(custId): Observable<any> {
    const get_url = BASE_API_URL + 'ippool/getIpPools/' + custId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }
  
  getIpPoolwithPartner(partnerId): Observable<any> {
    const get_url = BASE_API_URL + 'getIpPools/ByPartner/' + partnerId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }



  getIpPoolAllByPartner(partnerId): Observable<any> {
    const get_url = BASE_API_URL + 'ippool/getIpPools/ByPartner/' + partnerId;
    return this.http.get<any>(get_url,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  // ipPoolBlockIpByPoolDetailsIdAndCustId(poolDetailsId:number,custId:number): Observable<any> {
  //   const post_url = BASE_API_URL + 'ippool/blockIP/'+poolDetailsId+'/'+custId;
  //   return this.http.post<any>(post_url,{ headers: httpOptions.headers}).pipe(
  //       map((res: any) => {
  //         return res;
  //       }),
  //       catchError((error: any) => {
  //         return throwError(error);
  //       })
  //     );
  // }

  ipPoolBlockIpByPoolDetailsIdAndCustId(data:any): Observable<any> {
    const post_url = BASE_API_URL + 'ippool/blockIP';
    return this.http.post<any>(post_url,data,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }


  getNonAllocatedIp(params:HttpParams): Observable<any> {
    
    // let params = new HttpParams();
    // if (paginationData) {
    //   params = params.set('page', paginationData.pageNumber.toString());
    //   params = params.set('pageSize', paginationData.rowsPerPage.toString());
    // }
    // if (orderingData) {
    //   params = params.set('sortBy', orderingData.column);
    //   params = params.set('sortOrder', (orderingData.descending ? 1 : 0) + '');
    // }
    // if (search) {
    //   params = params.set('search', search);
    // }
    // params = params.set('poolId', poolId);
    // params = params.set('custId',custId);
    // const get_url = BASE_API_URL + 'ippool/getNonAllocatedIp';
    const post_url = BASE_API_URL + 'ippool/getIpByGlobalSearch';
    return this.http.post<any>(post_url,params,{ headers: httpOptions.headers}).pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }


}
